import { OrgNode } from '../services/orgs/interfaces';

export const generateDescription = ({
  org,
  formValues,
}: {
  org?: OrgNode;
  formValues?: Record<string, string>;
}) => {
  return `Raise Connect account for ${
    org?.fields.legal_name || org?.name || formValues?.kybPayableName
  }  - processing charges for school and non-profit organization digital fundraising`;
};
